document.addEventListener('DOMContentLoaded', () => {
    const el = document.querySelector('.product-details-card .pdc-swiper');
    if (!el) {
        // No product details card swiper found, do nothing.
        return;
    }
    const spaceBetweenMobile = parseFloat(el.getAttribute('data-space-between-mobile')) || 10;
    const slidesPerViewMobile = parseFloat(el.getAttribute('data-slides-per-view-mobile')) || 1.3;
    const spaceBetweenTablet = parseFloat(el.getAttribute('data-space-between-tablet')) || 15;
    const slidesPerViewTablet = parseFloat(el.getAttribute('data-slides-per-view-tablet')) || 2;
    const spaceBetweenDesktop = parseFloat(el.getAttribute('data-space-between-desktop')) || 20;
    const slidesPerViewDesktop = parseFloat(el.getAttribute('data-slides-per-view-desktop')) || 3;
    var swiper = new Swiper('.product-details-card .pdc-swiper', {
        spaceBetween: spaceBetweenMobile,
        slidesPerView: slidesPerViewMobile,
        grabCursor: true,
        keyboard: true,
        navigation: {
            nextEl: '.product-details-card .swiper-button-next',
            prevEl: '.product-details-card .swiper-button-prev',
        },
        breakpoints: {
            750: {
                spaceBetween: spaceBetweenTablet,
                slidesPerView: slidesPerViewTablet,
            },
            1200: {
                spaceBetween: spaceBetweenDesktop,
                slidesPerView: slidesPerViewDesktop,
            },
        }
    });
});